module.exports = __webpack_public_path__ + "static/media/house.5341cecd.svg";